export const APP_STORE_URL =
  'https://apps.apple.com/us/app/ems-by-coachlms/id6754012875';

export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.coachems.app';

export function detectMobileStore(userAgent = '') {
  const normalizedAgent = userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(normalizedAgent)) {
    return 'app-store';
  }

  if (normalizedAgent.includes('android')) {
    return 'play-store';
  }

  return 'unknown';
}

export function buildDownloadUrl(currentUrl) {
  const url = new URL(currentUrl);
  return `${url.origin}/download`;
}

export function getStoreUrl(store) {
  if (store === 'app-store') {
    return APP_STORE_URL;
  }

  if (store === 'play-store') {
    return GOOGLE_PLAY_URL;
  }

  return null;
}
